import React from 'react';
import styled, { keyframes } from 'styled-components';
import { theme } from '../../../config/theme';

const rotate = keyframes`
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
`;

const sweep = keyframes`
    0% {
        clip-path: polygon(0% 0%, 0% 0%, 0% 0%, 50% 50%, 0% 0%, 0% 0%, 0% 0%);
    }
    50% {
        clip-path: polygon(0% 0%, 0% 100%, 0% 100%, 50% 50%, 100% 0%, 100% 0%, 0% 0%);
    }
    100% {
        clip-path: polygon(0% 0%, 0% 100%, 100% 100%, 50% 50%, 100% 100%, 100% 0%, 0% 0%);
    }
`;

interface SpinnerInterface {
    size?: number;
    spinnerColor?: string;
    spinnerWidth?: number;
    light?: boolean;
    spinDuration?: number;
}

const StyledSpinner = styled.div<SpinnerInterface>`
    width: ${({ size }) => size}px;
    height: ${({ size }) => size}px;
    border-radius: 50%;
    border: ${({ spinnerWidth }) => spinnerWidth}px solid
        ${({ spinnerColor, light, theme }) =>
            light ? theme.colors.white : spinnerColor};
    animation: ${sweep} ${({ spinDuration }) => spinDuration}s linear alternate
            infinite,
        ${rotate} ${({ spinDuration }) => spinDuration}s linear infinite;
`;

const Spinner: React.FC<SpinnerInterface> = ({
    size = 16,
    spinnerColor = theme.colors.primary.main,
    spinnerWidth = 2,
    spinDuration = 1.4,
    light,
}) =>
    <StyledSpinner
        size={size}
        spinnerWidth={spinnerWidth}
        spinnerColor={spinnerColor}
        spinDuration={spinDuration}
        light={light}
    />

export default Spinner;
